import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["currentPageName", "ancestors", "showHomeLink", "showOnlyLargeBreadcrumb", "data-test", "onClick", "metaData"];
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ExpandIcon } from '@sainsburys-tech/bolt-icons';
import BreadCrumbItem from './BreadcrumbItem';
import * as Styled from './Breadcrumb.styles';
var PARENT_META_DATA = {
  itemScope: true,
  itemType: 'http://schema.org/BreadcrumbList'
};

var Breadcrumb = function Breadcrumb(_ref) {
  var currentPageName = _ref.currentPageName,
      ancestors = _ref.ancestors,
      showHomeLink = _ref.showHomeLink,
      showOnlyLargeBreadcrumb = _ref.showOnlyLargeBreadcrumb,
      dataTest = _ref['data-test'],
      onClick = _ref.onClick,
      metaData = _ref.metaData,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      breadcrumbsExpanded = _useState2[0],
      toggleExpanded = _useState2[1];

  var handleClick = function handleClick(event, attrs) {
    toggleExpanded(false);
    onClick(event, attrs);
  };

  var toggleLayout = showOnlyLargeBreadcrumb ? 'xs-hidden' : 'sm-hidden';
  var activeLayout = showOnlyLargeBreadcrumb ? '' : 'xs-hidden sm-block';
  var ancestorsLength = ancestors.length;
  var parentMetaData = metaData ? PARENT_META_DATA : {};
  var homePath = '/';
  var isOpen = breadcrumbsExpanded;
  var isSingle = ancestors.length === 0 && showHomeLink;
  var isLargeOnly = showOnlyLargeBreadcrumb;
  return /*#__PURE__*/React.createElement(Styled.Nav, _extends({
    "aria-label": "Breadcrumb",
    "data-test": dataTest,
    isLargeOnly: isLargeOnly
  }, parentMetaData, props), /*#__PURE__*/React.createElement("ol", {
    className: "xs-row xs-middle xs-wrap sm-nowrap"
  }, showHomeLink && /*#__PURE__*/React.createElement(BreadCrumbItem, {
    name: "Home",
    href: homePath,
    onClick: function onClick(event) {
      return handleClick(event, {
        path: homePath,
        isHome: true
      });
    },
    index: 0,
    metaData: metaData,
    isOpen: isOpen,
    isSingle: isSingle,
    isLargeOnly: isLargeOnly,
    "data-test": "".concat(dataTest, "-item")
  }), ancestors && ancestors.map(function (_ref2, index) {
    var name = _ref2.name,
        path = _ref2.path;
    return /*#__PURE__*/React.createElement(BreadCrumbItem, {
      key: name,
      name: name,
      href: path,
      onClick: function onClick(event) {
        return handleClick(event, {
          path: path
        });
      },
      isLast: index + 1 === ancestorsLength,
      index: index + 1,
      metaData: metaData,
      isOpen: isOpen,
      isSingle: isSingle,
      isLargeOnly: isLargeOnly,
      "data-test": "".concat(dataTest, "-item")
    });
  }), currentPageName && /*#__PURE__*/React.createElement(BreadCrumbItem, {
    name: currentPageName,
    index: ancestorsLength + 1,
    isActive: true,
    className: activeLayout,
    "aria-current": "page",
    metaData: metaData,
    isOpen: isOpen,
    isSingle: isSingle,
    isLargeOnly: isLargeOnly,
    "data-test": "".concat(dataTest, "-item")
  }), ancestorsLength === 1 && showHomeLink || ancestorsLength > 1 ? /*#__PURE__*/React.createElement(Styled.ToggleButton, {
    className: toggleLayout,
    "data-test": "".concat(dataTest, "-button-expand"),
    "aria-hidden": "true",
    tabIndex: "0",
    onClick: function onClick() {
      return toggleExpanded(!breadcrumbsExpanded);
    }
  }, /*#__PURE__*/React.createElement(ExpandIcon, {
    height: "16",
    width: "16",
    expanded: !breadcrumbsExpanded
  })) : null));
};

Breadcrumb.propTypes = {
  currentPageName: PropTypes.string,
  ancestors: PropTypes.arrayOf(PropTypes.object),
  showHomeLink: PropTypes.bool,
  showOnlyLargeBreadcrumb: PropTypes.bool,
  onClick: PropTypes.func,
  metaData: PropTypes.bool,
  'data-test': PropTypes.string
};
Breadcrumb.defaultProps = {
  ancestors: [],
  onClick:
  /* istanbul ignore next */
  function onClick() {},
  showHomeLink: true,
  showOnlyLargeBreadcrumb: false,
  metaData: true,
  'data-test': 'component-breadcrumb'
};
export default Breadcrumb;